export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const APP_URL = "https://www.localawaaz.in";